// 视频请求地址
export const flvURLMap = new Map();

// 获取flvURL
export function getFlvURL(GUID, field = "flvURL") {
  if (!GUID) return null;
  const cacheData = flvURLMap.get(GUID);
  if (cacheData && cacheData.timeOut > Date.now()) {
    if (field === true) return cacheData; // 获取全部数据
    return cacheData[field]; // 数据中的某个字段
  }
  return null;
}

// 缓存flvURL
export function setFlvURL(GUID, flvURL, infoData = {}, timeOut = 1800) {
  flvURLMap.set(GUID, {
    ...infoData,
    flvURL,
    timeOut: Date.now() + timeOut * 1000, // 缓存超时时长
  });
}

// 有视频的车辆
export const hasVideoMap = new Map();

// 车辆树gps数据本地缓存
export const gpsMapData = new Map();

// 车辆通道信息
export const aisleDataMap = new Map();

let initSelectData = false;

// 企业数据缓存
export const AllComList = [];
export const ComValueIndex = new Map();

// 部门数据缓存
export const AllDepList = [];
export const AllChildren = new Map();
// eslint-disable-next-line import/no-mutable-exports
export let LevelOne = true;
const tempDepCommon = {};

// 车辆数据缓存
export const AllSOIDList = [];
export const AllCarIDList = [];
export const SOIDValueIndex = new Map();
export const CarIDValueIndex = new Map();

function filterChildren(depNode, level = 2) {
  const nodeList = depNode.children
    .map(item => {
      if (!tempDepCommon[item.Value]) {
        tempDepCommon[item.Value] = true;
        const depInfo = {};
        depInfo.id = item.id;
        depInfo.name = item.Name;
        depInfo.value = item.Value;
        depInfo.ComID = item.ComID;
        depInfo.ParentValue = item.ParentValue;
        depInfo.hasChildren = Boolean(item.children);
        depInfo.isOpen = false;
        depInfo.nodeLevel = level;
        depInfo.parentNodes = [
          ...item._aParentID
            .map(child => Number(child.split("-").pop()))
            .slice(0, -1)
        ];
        AllDepList.push({ ...depInfo });
        if (depInfo.hasChildren) {
          const nextLevel = level + 1;
          filterChildren(item, nextLevel);
        }
        return depInfo;
      }
      return null;
    })
    .filter(Boolean);
  AllChildren.set(depNode.Value, nodeList);
}

export function initValueData() {
  // 不加载车辆权限树数据 add by chenk 2021.11.15
  if (StarSoft.SysInfo.UnLoadCarTreeData) {
    initSelectData = true;
    return;
  }
  StarSoft.Data.fGetData(StarSoft.Data.Dict.GetPowerCarTree, results => {
    if (results.bFinish) {
      // 公司数据初始化
      const comList = results.aCom || [];
      let ComIndex = 0;
      comList.forEach(item => {
        if (item.IsGov) return; // 过滤掉协会
        const comInfo = {};
        comInfo.id = item.id;
        comInfo.name = item.Name;
        comInfo.value = item.Value;
        AllComList.push(comInfo);
        ComValueIndex.set(item.Value, ComIndex);
        ComIndex++;
      });
      // 部门数据初始化
      const depList = results.aDept || [];
      depList.forEach(item => {
        if (item.ParentType == 10) {
          if (!tempDepCommon[item.Value]) {
            tempDepCommon[item.Value] = true;
            const depInfo = {};
            depInfo.id = item.id;
            depInfo.name = item.Name;
            depInfo.value = item.Value;
            depInfo.ComID = item.ComID;
            depInfo.ParentValue = item.ParentValue;
            depInfo.hasChildren = Boolean(item.children);
            depInfo.isOpen = false;
            depInfo.nodeLevel = 1;
            AllDepList.push(depInfo);
            if (depInfo.hasChildren) {
              LevelOne = false;
              filterChildren(item);
            }
          }
        }
      });
      // 车辆数据初始化
      const carList = results.aCar || [];
      let SIndex = 0;
      carList.forEach((item, index) => {
        const carInfo = {};
        carInfo.id = item.id;
        carInfo.name = item.Name;
        carInfo.SelfNum = item.SelfNum;
        carInfo.value = item.Value;
        carInfo.ComID = item.ComID;
        carInfo.ParentValue = item.ParentValue;
        // CarID 主键序列化
        AllCarIDList.push(carInfo);
        CarIDValueIndex.set(item.Value, index);
        // SOID 主键序列化
        if (item.SOID) {
          AllSOIDList.push({ ...carInfo, value: item.SOID });
          SOIDValueIndex.set(item.SOID, SIndex);
          SIndex++;
        }
      });
      initSelectData = true;
    }
  });
}

// promise 等待数据初始化
export function waitTreeData() {
  function sleepTime(resolve) {
    if (initSelectData) {
      resolve();
    } else {
      setTimeout(() => {
        sleepTime(resolve);
      }, 100);
    }
  }
  return new Promise(resolve => {
    sleepTime(resolve);
  });
}

export const getFollowTags = () =>
  new Promise(resolve => {
    fetch(
      `${StarSoft.SysInfo.V8}MC6/api/Alarm/AlarmFollow/GetFollowTagsAsync`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          loginKey: StarSoft.LoginKey
        }
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.Suc) {
          const CustomTags = data.Data.CustomTags || [];
          const CompanyTags = data.Data.CompanyTags || [];
          const outList = [...CustomTags, ...CompanyTags];
          resolve(outList);
        } else {
          resolve([]);
        }
      })
      .catch(() => {
        resolve([]);
      });
  });

export const getFollowList = () =>
  new Promise(resolve => {
    fetch(
      `${StarSoft.SysInfo.V8}MC6/api/Alarm/AlarmFollow/GetFollowListAsync`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          loginKey: StarSoft.LoginKey
        }
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.Suc) {
          const outList = data.Data || [];
          resolve(outList);
        } else {
          resolve([]);
        }
      })
      .catch(() => {
        resolve([]);
      });
  });

const NoticeTemplateData = {
  init: false,
  list: []
};

export const getNoticeTemplate = () => NoticeTemplateData;

export const setNoticeTemplate = ({ init, list }) => {
  NoticeTemplateData.init = init;
  NoticeTemplateData.list = list;
};
